import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  tiposServicios: [],
  fetchTiposServiciosLoading: false,
  fetchTiposServiciosError: null,

  addTipoServicioLoading: false,
  addTipoServicioError: null,

  updateTipoServicioLoading: false,
  updateTipoServicioError: null,

  deleteTipoServicioLoading: false,
  deleteTipoServicioError: null
};

export const tipoServicioSlice = createSlice({
  name: 'TIPOSERVICIOS',
  initialState,
  reducers: {
    fetchTiposServiciosStart: state => {
      state.fetchTiposServiciosLoading = true;
      state.fetchTiposServiciosError = null;
    },
    fetchTiposServiciosSuccess: (state, action) => {
      state.fetchTiposServiciosLoading = false;
      state.tiposServicios = action.payload;
    },
    fetchTiposServiciosError: (state, action) => {
      state.fetchTiposServiciosLoading = false;
      state.fetchTiposServiciosError = action.payload;
    },

    addTipoServicioStart: state => {
      state.addTipoServicioLoading = true;
      state.addTipoServicioError = null;
    },
    addTipoServicioSuccess: (state, action) => {
      state.addTipoServicioLoading = false;
      state.tiposServicios.unshift(action.payload);
    },
    addTipoServicioError: (state, action) => {
      state.addTipoServicioLoading = false;
      state.addTipoServicioError = action.payload;
    },

    updateTipoServicioStart: state => {
      state.updateTipoServicioLoading = true;
      state.updateTipoServicioError = null;
    },
    updateTipoServicioSuccess: (state, action) => {
      state.updateTipoServicioLoading = false;
      const newState = state.tiposServicios.map(tipoServ => {
        if (tipoServ.id === action.payload.id) return action.payload;
        return tipoServ;
      });
      state.tiposServicios = newState;
    },
    updateTipoServicioError: (state, action) => {
      state.updateTipoServicioLoading = false;
      state.updateTipoServicioError = action.payload;
    },

    deleteTipoServicioStart: state => {
      state.deleteTipoServicioLoading = true;
      state.deleteTipoServicioError = null;
    },
    deleteTipoServicioSuccess: (state, action) => {
      state.deleteTipoServicioLoading = false;
      const newState = state.tiposServicios.filter(
        tipoServ => tipoServ.id !== action.payload.id
      );
      state.tiposServicios = newState;
    },
    deleteTipoServicioError: (state, action) => {
      state.deleteTipoServicioLoading = false;
      state.deleteTipoServicioError = action.payload;
    }
  }
});

export const {
  fetchTiposServiciosStart,
  fetchTiposServiciosSuccess,
  fetchTiposServiciosError,
  addTipoServicioStart,
  addTipoServicioSuccess,
  addTipoServicioError,
  updateTipoServicioStart,
  updateTipoServicioSuccess,
  updateTipoServicioError,
  deleteTipoServicioStart,
  deleteTipoServicioSuccess,
  deleteTipoServicioError
} = tipoServicioSlice.actions;

export default tipoServicioSlice.reducer;
